'use es6';

export const Networks = {
  ADWORDS: 'ADWORDS',
  FACEBOOK: 'FACEBOOK',
  LINKEDIN: 'LINKEDIN',
  NONE: 'NONE'
};